module.exports = __webpack_public_path__ + "img/flags32.5bd4c3d9.png";